import { FC } from 'react';

import {
    StyledPrimaryNav,
    PrimaryListWrapper,
    LinkWrapper,
    AccordionIcon,
    AccountMenu
} from './PrimaryNav.styles';
import SecondaryNav from './SecondaryNav';
import { SubItems } from '../../HeaderStructure';
import {
    StyledMenuList,
    StyledNavLink
} from './SecondaryNav/SecondaryNav.styles';
import { ResetLink } from '../../Header.styles';

type Props = {
    navItems: SubItems;
};

const PrimaryNav: FC<Props> = (props) =>
    props.navItems ? (
        <StyledPrimaryNav>
            <PrimaryListWrapper>
                <AccountMenu
                    key={'primarymenu-account'}
                    data-testid={'header-primarynav-account'}
                    data-is-logged-in="true"
                >
                    <LinkWrapper
                        data-testid="header-primarynav-accordion"
                        data-universal-header-menu={`menu${'account'}`}
                        data-track-category="User Account"
                        data-track-action="click"
                        data-track-label="user account>expand"
                    >
                        <AccordionIcon role="presentation" />
                        <ResetLink
                            href={'/myaccount/'}
                            data-testid="header-profile-account"
                            data-track-category="User Account"
                            data-track-action="clickthrough"
                            data-track-label="user account"
                        >
                            My Zoopla
                        </ResetLink>
                    </LinkWrapper>
                    <SecondaryNav>
                        <StyledMenuList>
                            <li>
                                <StyledNavLink
                                    href="/favourites/properties/"
                                    data-testid="header-profilemenu-saved-listings"
                                    data-track-category="User Account"
                                    data-track-action="clickthrough"
                                    data-track-label="user account>favourite properties"
                                >
                                    Saved listings
                                </StyledNavLink>
                            </li>
                            <li>
                                <StyledNavLink
                                    href="/favourites/tracked-properties/"
                                    data-testid="header-profilemenu-tracked-properties"
                                    data-track-category="User Account"
                                    data-track-action="clickthrough"
                                    data-track-label="user account>tracked properties"
                                >
                                    Tracked properties
                                </StyledNavLink>
                            </li>
                            <li>
                                <StyledNavLink
                                    href="/myaccount/alerts-searches/"
                                    data-testid="header-profilemenu-alerts-searches"
                                    data-track-category="User Account"
                                    data-track-action="clickthrough"
                                    data-track-label="user account>alerts & searches"
                                >
                                    Alerts and searches
                                </StyledNavLink>
                            </li>
                            <li>
                                <StyledNavLink
                                    href="/myaccount/account/preferences/"
                                    data-testid="header-profilemenu-email-preferences"
                                    data-track-category="User Account"
                                    data-track-action="clickthrough"
                                    data-track-label="user account>email preferences"
                                >
                                    Email preferences
                                </StyledNavLink>
                            </li>
                            <li>
                                <StyledNavLink
                                    href="/myaccount/"
                                    data-testid="header-profilemenu-account"
                                    data-track-category="User Account"
                                    data-track-action="clickthrough"
                                    data-track-label="user account>manage account"
                                >
                                    More account settings
                                </StyledNavLink>
                            </li>
                            <li>
                                <StyledNavLink
                                    href="/?signout=1"
                                    data-is-logged-in="true"
                                    data-testid="header-profilemenu-sign-out"
                                    data-track-category="User Account"
                                    data-track-action="clickthrough"
                                    data-track-label="user account>sign out"
                                    data-ajax="false"
                                >
                                    Sign out
                                </StyledNavLink>
                            </li>
                        </StyledMenuList>
                    </SecondaryNav>
                </AccountMenu>
                {props.navItems.map((item, idx) => (
                    <li
                        key={'primarymenu-' + idx}
                        data-testid={'header-primarynav-' + item.id}
                    >
                        <LinkWrapper
                            data-testid="header-primarynav-accordion"
                            data-universal-header-menu={`menu${idx}`}
                        >
                            <AccordionIcon role="presentation" />
                            <ResetLink
                                href={item.uri}
                                data-testid="header-primarynav-link"
                                data-track-category="navbar"
                                data-track-action="clickthrough"
                                data-track-label={item.tracking}
                            >
                                {item.label}
                            </ResetLink>
                        </LinkWrapper>
                        {item.subnavs ? (
                            <SecondaryNav
                                parentTracking={item.tracking}
                                subNavs={item.subnavs}
                            />
                        ) : null}
                    </li>
                ))}
            </PrimaryListWrapper>
        </StyledPrimaryNav>
    ) : null;

export default PrimaryNav;
